export default "__VITE_ASSET__fb4c6d08__"